import { JSONValue } from "ai";
import z from "zod/v4";

export const LanguageModelSchema = z
  .string()
  .refine((val) => val.startsWith("openai:"), {
    message: 'Language model must start with "openai:"',
  });
export type LanguageModel = `openai:${string}`;

export const JSONValueSchema: z.ZodType<JSONValue> = z.lazy(() =>
  z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(JSONValueSchema),
    z.record(z.string(), JSONValueSchema),
  ])
);

export const SupportedOpenAiModels = [
  "openai:o1",
  "openai:o1-mini",
  "openai:o3-mini",
  "openai:o3",
  "openai:o4-mini",
  "openai:gpt-4.1",
  "openai:gpt-4o",
  "openai:gpt-4o-mini",
  "openai:gpt-4-turbo",
  "openai:gpt-4",
] as const;

export const SupportedGoogleModels = [
  "google:gemini-1.5-flash-latest",
  "google:gemini-1.5-flash-8b-latest",
  "google:gemini-1.5-pro-latest",
  "google:gemini-2.0-flash",
  "google:gemini-2.0-flash-001",
  "google:gemini-2.0-flash-live-001",
  "google:gemini-2.0-flash-lite",
  "google:gemini-2.0-pro-exp-02-05",
  "google:gemini-2.0-flash-thinking-exp-01-21",
  "google:gemini-2.0-flash-exp",
  "google:gemini-2.5-pro-exp-03-25",
  "google:gemini-2.5-flash-preview-04-17",
];

export const SupportedAnthropicModels = [
  "anthropic:claude-4-opus-20250514",
  "anthropic:claude-4-sonnet-20250514",
];

export const SupportedAiModels = [
  ...SupportedOpenAiModels,
  ...SupportedGoogleModels,
  ...SupportedAnthropicModels,
];
